import { Mesh, MeshBasicMaterial, SphereGeometry } from "three";

export class Sphere360 extends Mesh {
	constructor(radius = 5, width = 32, height = 16, texture = "") {
		super();
		this.geometry = new SphereGeometry(radius, width, height);
		this.geometry.scale(-1, 1, 1);
		this.material = new MeshBasicMaterial({ color: 0xffffff, transparent: true });
	}

	onUpdateTexture(material) {
		this.material = material;
	}
}
